import React from "react";
import {
  tagsData,
  GetInTouch,
  Connections,
  Earnings,
  Account,
} from "../../mock/tags";
import {
  Column,
  Container,
  Title,
  FirstWrapper,
  SecondWrapper,
  Link,
  Tags,
  TagsWrapper,
  Copyright,
} from "./style";

export default function Footer() {
  return (
    <Container>
      {/* first section  */}
      <FirstWrapper>
        <Column>
          <Title>Get in touch</Title>
          {GetInTouch.map((value, index) => (
            <Link key={index} href={value.link}>
              {value.title}
            </Link>
          ))}
        </Column>
        <Column>
          <Title>Connections</Title>
          {Connections.map((value, index) => (
            <Link key={index} href={value.link}>
              {value.title}
            </Link>
          ))}
        </Column>
        <Column>
          <Title>Earnings</Title>
          {Earnings.map((value, index) => (
            <Link key={index} href={value.link}>
              {value.title}
            </Link>
          ))}
        </Column>
        <Column>
          <Title>Account</Title>
          {Account.map((value, index) => (
            <Link key={index} href={value.link}>
              {value.title}
            </Link>
          ))}
        </Column>
      </FirstWrapper>

      {/* second section  */}
      <SecondWrapper>
        <Title>Product Tags</Title>
        <TagsWrapper>
          {tagsData.map((value, index) => (
            <Tags key={index}>{value}</Tags>
          ))}
        </TagsWrapper>
      </SecondWrapper>
      <Copyright>Copyright © {new Date().getFullYear()} Webbrain.com</Copyright>
    </Container>
  );
}
